import { stringifyUrl, type UrlObject } from 'query-string'

export const generateSearchParams = (query: UrlObject['query']): string => {
    const url = window.location.search
    return stringifyUrl({ url, query }, { skipEmptyString: true })
}
